import { render, staticRenderFns } from "./UsuarioAnexosDialog.vue?vue&type=template&id=6f7bd9ca"
import script from "./UsuarioAnexosDialog.vue?vue&type=script&lang=js"
export * from "./UsuarioAnexosDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports